import { EligibleDependentAction } from "../../types/contexts/eligibleDependentContext/eligibleDependentAction.types";
import { Store } from "../../types/contexts/eligibleDependentContext/store.types";
import actions from "./actions";

const reducer = (state: Store, action: EligibleDependentAction): Store => {
	switch (action.type) {
		case actions.SET_ELIGIBLE_DEPENDENT: {
			return {
				...state,
				...action.payload
			};
		}
		default:
			throw new Error("Unexpected action: Eligiblity Context");
	}
};

export default reducer;
